$(document).ready(function() {
	var dirRtlFlag = false;
	if ($("html").attr('dir') == 'rtl') {
		dirRtlFlag = true;
	}

	
// articles slider
$('#hp-services').slick({
	dots: false,
	infinite: true,
	speed: 2000,
	slidesToShow: 5, 
	slidesToScroll: 1,
	arrows: false, 
	autoplay: true,
	autoplaySpeed: 3000,
	rtl: dirRtlFlag,
	responsive: [{
			breakpoint: 1400, 
			settings: {
				slidesToShow: 4,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 1100,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1
			}
		},
		{
			breakpoint: 993,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			}
		},
		{
			breakpoint: 769,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
	]
});


$('.prev-serv').click(function() {
	$('#hp-services').slick('slickPrev');
	return false;
});

$('.next-serv').click(function() {
	$('#hp-services').slick('slickNext');
	return false;
});

// articles slider
	$('#hp-articles').slick({
		dots: false,
		infinite: true,
		speed: 2000,
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 3000,
		rtl: dirRtlFlag,
		responsive: [{
				breakpoint: 1350,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			}, {
				breakpoint: 1100,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 993,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});

	
	$('.prev-art').click(function() {
		$('#hp-articles').slick('slickPrev');
		return false;
	});

	$('.next-art').click(function() {
		$('#hp-articles').slick('slickNext');
		return false;
	});


})